<template>
  <div class="subtitle-guidance" v-show="isShow">
    <div
      ref="fakeDialog"
      v-if="step === 1"
      class="fake-dialog"
      :style="{
        position: 'absolute',
        top: 50 + '%',
        leftx: 50 + '%',
        transform: `translatey(-50%)`,
        width: tips[1].dialog.w + 'px',
        height: tips[1].dialog.h + 'px',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${tips[1].dialog.url})`,
      }"
    ></div>

    <div
      class="subtitle-tip-box"
      :class="['stage-' + i]"
      v-for="(t, i) in tips"
      :style="{
        width: t.rect.w + 'px',
        height: t.rect.h + 'px',
        top: t.rect.y + 'px',
        left: t.rect.x + 'px',
      }"
      v-show="step == i"
    >
      <div class="tip-box-timeline" v-if="i == 0">
        <div class="range range-1" :style="{ width: rangeSize + 'px' }">
          <div class="add-btn">
            <i></i>
            <span>添加字幕</span>
          </div>
        </div>
        <div class="range range-2" :style="{ width: rangeSize + 'px' }">
          <div class="add-btn">
            <i></i>
            <span>添加配音</span>
          </div>
        </div>
        <div class="range range-3" :style="{ width: rangeSize + 'px' }">
          <div class="add-btn">
            <i></i>
            <span>添加配乐</span>
          </div>
        </div>
        <div class="slider-timeline">
          <div class="slider-box" data-action="handle"></div>
          <div class="slider-line">
            <div data-action="handle"></div>
          </div>
        </div>

        <div class="show-hide-btn">
          <div class="">
            <i class="iconfont iconzimu"></i>
          </div>
          <div class="">
            <i class="iconfont iconpeiyin"></i>
          </div>
          <div class="">
            <i class="iconfont iconpeile"></i>
          </div>
          <!-- <div class="hide-status">
            <i class="iconfont iconyinxiao"></i>
          </div> -->
        </div>

        <div class="btns-tip">此处展开/关闭时间轴</div>
      </div>
      <div class="tip-box-smart-voice" v-if="i == 1">
        <div class="btn">
          <i></i>
          <span>添加配音</span>
        </div>
      </div>
      <div class="tip-box-panel" v-if="i == 2">
        <div data-v-23295520="" class="soundSet-pane" style="">
          <div class="tabTitle">
            <p>配乐设置</p>
          </div>
          <div class="soundtrack-container">
            <div class="soundtrack-item">
              <div class="soundtrack-item-name">
                <p>Lakeside Drive</p>
              </div>
              <div class="soundtrack-operate">
                <div class="play-shell">
                  <div class="play-btn iconfont play-btn-play"></div>
                </div>
                <div class="soundtrack-bar" style="height: 100%">
                  <audio
                    src="https://resources.laihua.com/2020-08-04/87284146-d5fc-11ea-ac7f-acde48001122.mp3"
                    controls="controls"
                    volume="50"
                    style="display: none"
                  ></audio>
                  <div>
                    <div
                      role="slider"
                      aria-valuemin="0"
                      aria-valuemax="171"
                      aria-orientation="horizontal"
                      class="el-slider"
                      aria-valuetext="0"
                      aria-label="slider between 0 and 0"
                    >
                      <div class="el-slider__runway">
                        <div
                          class="el-slider__bar"
                          style="left: 0%; width: 0%"
                        ></div>
                        <div
                          tabindex="0"
                          class="el-slider__button-wrapper"
                          style="left: 0%"
                        >
                          <div
                            class="el-tooltip el-slider__button"
                            aria-describedby="el-tooltip-953"
                            tabindex="0"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="soundtrack-times">
                  <span class="music-time-msg">02:51</span>
                </div>
              </div>
              <div style="text-align: left">
                <span class="iconfont soundDown icon3912"></span>
                <span class="endStronger">结尾渐弱</span>
              </div>
            </div>
            <div class="soundtrack-btn">
              <div class="soundtrack-btn-2">
                <button
                  type="button"
                  class="el-button replace-btn el-button--default el-button--small"
                >
                  <span>替换</span>
                </button>
                <button
                  type="button"
                  class="el-button clip-btn el-button--default el-button--small"
                >
                  <span>剪辑</span>
                </button>
              </div>
              <div>
                <button
                  type="button"
                  class="el-button soundtrack-delete el-button--default el-button--small"
                >
                  <span>删除</span>
                </button>
              </div>
            </div>
          </div>
          <div style="height: 100%; position: relative; display: none">
            <p class="noMUsic">未选中任何元素</p>
          </div>
        </div>
      </div>
      <div class="tip-box-ai" v-if="i == 3">
        <div class="icon"></div>
        <div>配音转字幕</div>
      </div>
      <div class="tip-box-btn" v-if="i == 4">{{ t.rect.text }}</div>
      <div
        class="tip-box-line"
        :style="{
          width: t.tip.w + 'px',
          height: t.tip.h + 'px',
          top: t.tip.y + 'px',
          left: t.tip.x + 'px',
          backgroundImage: `url(${t.tip.url})`,
        }"
      ></div>
      <div
        v-if="step == 1"
        class="tip-box-line"
        :style="{
          width: tips[1].tip2.w + 'px',
          height: tips[1].tip2.h + 'px',
          top: tips[1].tip2.y + 'px',
          left: tips[1].tip2.x + 'px',
          backgroundImage: `url(${tips[1].tip2.url})`,
        }"
      ></div>
      <div
        class="tip-box-content"
        :style="{
          width: t.content.w + 'px',
          height: t.content.h + 'px',
          top: t.content.y + 'px',
          left: t.content.x + 'px',
        }"
      >
        <p class="title">{{ t.content.title }}</p>
        <p class="text" v-html="t.content.text"></p>
        <div class="control">
          <div class="mark">
            <span>{{ i + 1 }}</span
            >/{{ tips.length }}
          </div>
          <div class="main">
            <div class="skip" @click="skip">跳过</div>
            <div @click="next" class="next">{{ i != 4 ? '下一步' : 'OK' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      isShow: false,
      tips: [
        {
          rect: {
            x: 0,
            y: 0,
            w: 88,
            h: 34,
          },
          tip: {
            x: 290,
            y: -9,
            w: 112,
            h: 60,
            url: '../../../static/svg/subtitle/tipline01.svg'
          },
          content: {
            x: 416,
            y: -60,
            w: 286,
            h: 151,
            text: "字幕、配音、配乐时间轴全新升级，可在时间轴区域<b>添加内容</b>并<b>拖拽改变位置</b>。",
            title: '全新时间轴'
          }
        }, {
          rect: {
            x: 0,
            y: 0,
            w: 0,
            h: 0,
            text: ""
          },
          tip: {
            x: 320,
            y: 714,
            w: 130,
            h: 103,
            url: '../../../static/svg/subtitle/tipline04.png',
            style: {
              transform: `rotate(-22deg) scale(2)`
            }
          },
          dialog: {
            w: 672,
            h: 405,
            url: '../../../static/svg/subtitle/fake-dialog.png',
          },
          tip2: {
            x: 320,
            y: 714,
            w: 99,
            h: 111,
            url: '../../../static/svg/subtitle/tipline02.svg',
          },
          content: {
            x: 225,
            y: -147,
            w: 286,
            h: 151,
            title: 'AI配音全新升级',
            text: "多角色对话、批量添加配音，让你的配音体验火箭式提升！"
          }
        }, {
          rect: {
            x: 0,
            y: 0,
            w: 0,
            h: 0,
            text: "智能识别"
          },
          tip: {
            x: -120,
            y: 30,
            w: 90,
            h: 111,
            url: '../../../static/svg/subtitle/tipline02.svg',

          },
          content: {
            x: -300,
            y: 140,
            w: 286,
            h: 151,
            title: '声音设置',
            text: "声音文件可在此处<b>设置渐弱</b>、<b>剪辑起止</b>和<b>替换</b>。"
          }
        }, {
          rect: {
            x: 0,
            y: 0,
            w: 0,
            h: 0,
            text: "智能识别"
          },
          tip: {
            x: 0,
            y: 20,
            w: 98,
            h: 55,
            url: '../../../static/svg/subtitle/tipline02.svg'
          },
          content: {
            x: 0,
            y: 81,
            w: 286,
            h: 151,
            title: '配音转字幕',
            text: "支持将视频中的配音内容智能识别<b>一键转为字幕</b>，会员功能现在<b>限免试用</b>哦！"
          }
        }, {
          rect: {
            x: 0,
            y: 12,
            w: 112,
            h: 36,
            text: "返回画布"
          },
          tip: {
            x: -47,
            y: 45,
            w: 93,
            h: 66,
            url: '../../../static/svg/subtitle/tipline03.svg'
          },
          content: {
            x: -276,
            y: 120,
            w: 286,
            h: 249,
            title: '大功告成，返回画布',
            text: `点击则保存并返回视频创作界面，随时可回来继续编辑哦！<br>😊<b>制作建议：</b><br>字幕与配音请放到视频制作的<b>最后一步</b>，避免视频调整导致字幕配音位置错乱。<br>
祝创作愉快~`
          }
        }
      ],
      step: 0,
      rangeSize: 0
    }
  },
  computed: {
    ...mapGetters([
      'UserMsg'
    ])
  },
  watch: {
    'UserMsg.versionNumber': function (val, oldval) {
      if (this.UserMsg.versionNumber > 400 && this.UserMsg.versionNumber < this.UserMsg.versionTOOL) {
        if (!localStorage.getItem('hasUseSubtitle')) {
          this.isShow = true;
          this.initStyle()
        }
      }
    },
    isShow (val) {
      if (!val) {
        this.$store.commit("smartVoice/setSmartVoiceDialogVisible", false);
      }
    }
  },
  created () {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize);
  },
  mounted () {
    if (!localStorage.getItem('hasUseSubtitle')) {
      this.isShow = true;
      this.initStyle()
    }
  },
  methods: {
    onResize () {
      clearTimeout(this.tid);
      this.tid = setTimeout(() => {
        this.initStyle();
      }, 800);
    },
    initStyle () {
      this.$nextTick(() => {
        let dx = window.scrollX,
          dy = window.scrollY,
          box = { x: 0, y: 0, w: 0, h: 0 };

        ({ left: box.x, top: box.y, width: box.w, height: box.h } = $("#timeline-area")[0].getBoundingClientRect())
        box.x += dx
        box.y += dy
        let stage = this.tips[0];
        Object.assign(stage.rect, box);
        stage.tip.y = 40 - stage.tip.h;
        stage.content.y = 20 - stage.content.h;

        let rect = $('.timeline-box-body')[0].getBoundingClientRect();
        this.rangeSize = rect.width - 10;
        // ----------第一个----------
        stage = this.tips[1];
        Object.assign(stage.rect, box);
        stage.tip.x = 240;
        stage.tip.y = 82 - stage.tip.h;
        stage.content.x = box.w - stage.content.w * 0.7;
        stage.content.y = - stage.content.h - box.h;
        // stage.dialog.w = 946;
        // stage.dialog.h = 569;
        this.updateDialog();
        // ----------第二个----------
        ({ left: box.x, top: box.y, width: box.w, height: box.h } = $("#right-area")[0].getBoundingClientRect())
        box.x += dx
        box.y += dy
        stage = this.tips[2];
        Object.assign(stage.rect, box);
        // ----------第三个----------
        ({ left: box.x, top: box.y, width: box.w, height: box.h } = $(".editToolbar .ai_discern_button")[0].getBoundingClientRect())
        box.x += dx
        box.y += dy
        stage = this.tips[3];
        Object.assign(stage.rect, box);
        stage.tip.x = box.w + 7
        stage.content.x = box.w + 56
        // 返回画布按钮
        stage = this.tips[4];
        if (this.$route.subtitle) {
          stage.rect.w = 80
          stage.rect.text = '导出'
          stage.rect.text = '完成字幕之后点击导出为作品，在我的创作-我的作品中查看。'
        }
        stage.rect.x = window.innerWidth - stage.rect.w - 10
      })
    },
    next () {
      this.step++;
      if (this.step === 1) {
        this.$nextTick(() => {
          this.updateDialog();
        });
      }
      // if (this.step === 1) {
      //   this.$store.commit("smartVoice/setSmartVoiceDialogVisible", true);
      //   this.$el.style.backgroundColor = 'transparent';
      // } else {
      //   this.$store.commit("smartVoice/setSmartVoiceDialogVisible", false);
      //   this.$el.style.backgroundColor = '';
      // }
      if (this.step === 5) {
        this.isShow = false
        localStorage.setItem('hasUseSubtitle', true)
      }
    },
    skip () {
      this.isShow = false;
      localStorage.setItem('hasUseSubtitle', true)
    },
    updateDialog () {
      let stage = this.tips[1];
      let d = stage.content.x - (stage.tip.x + stage.tip.w);
      if (d) {
        stage.dialog.w = Math.min(d - 20, 946);
        stage.dialog.h = Math.min(d * 569 / 946, 569);
        if (this.$refs.fakeDialog) {
          this.$refs.fakeDialog.style.left = (stage.tip.x + stage.tip.w + 10) + 'px';
          stage.content.x = stage.tip.x + stage.tip.w + stage.dialog.w + 20;
        }
        stage.tip2.x = stage.content.x;
        stage.tip2.y = stage.content.y - stage.tip2.h - 10;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './soundtrack/common.scss';
.subtitle-guidance {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1002;
}
.fake-dialog {
  width: 946px;
  height: 569px;
}
@media (max-width: 1440px) {
  .fake-dialog {
    width: 672px;
    height: 405px;
  }
}
.stage-2 {
  & .tip-box-line {
    transform: scaleX(-1);
  }
}
.stage-4 {
  .tip-box-content .text {
    line-height: 1.75;
  }
  .tip-box-content > .control .mark {
    visibility: hidden;
  }
  .tip-box-content > .control .skip {
    visibility: hidden;
  }
}
.subtitle-tip-box {
  position: relative;
}
.tip-box-btn {
  position: absolute;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
  color: #ffffff;
  background-color: #5778fb;
  font-size: 14px;
  border-radius: 4px;
}
.tip-box-timeline {
  .range {
    height: 24px;
    width: 100px;
    background-color: #e5e6f0;
    border-radius: 4px;
    position: absolute;
    left: 188px;
    top: 47px;
    & .add-btn {
      position: relative;
      top: 0;
      display: flex;
      align-items: center;
      height: 24px;
      width: 80px;
      cursor: pointer;

      i {
        position: relative;
        width: 20px;
        height: 20px;

        &:before {
          position: absolute;
          top: 10px;
          left: 6px;
          display: block;
          content: ' ';
          width: 9px;
          height: 1px;
          background-color: #474261;
        }

        &:after {
          position: absolute;
          top: 6px;
          left: 10px;
          content: ' ';
          width: 1px;
          height: 9px;
          background-color: #474261;
        }
      }

      span {
        font-size: 12px;
        color: #474261;
      }
    }
  }
  .range-2 {
    top: 82px;
  }
  .range-3 {
    top: 115px;
  }
  & > .btns-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 24px;
    bottom: 29px;
    width: 148px;
    height: 29px;
    background: #ffffff;
    opacity: 1;
    border-radius: 4px;
  }
}
.tip-box-smart-voice {
  & > .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 82px;
    left: 187px;
    width: 82px;
    height: 24px;
    background: #ffffff;
    border: 1px solid #5778fb;
    opacity: 1;
    border-radius: 12px;

    i {
      width: 8px;
      height: 20px;

      &:before {
        position: absolute;
        top: 10px;
        left: 6px;
        display: block;
        content: ' ';
        width: 9px;
        height: 1px;
        background-color: #474261;
      }

      &:after {
        position: absolute;
        top: 6px;
        left: 10px;
        content: ' ';
        width: 1px;
        height: 9px;
        background-color: #474261;
      }
    }

    span {
      font-size: 12px;
      color: #474261;
    }
  }
}
.tip-box-panel {
  height: 100%;
}
.tip-box-ai {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fafaff;
  width: 100%;
  height: 100%;
  padding: 0 10px;
  border-radius: 4px;
  color: #474261;
  line-height: 34px;

  .icon {
    width: 16px;
    height: 13px;
    background: url('../../../static/svg/subtitle/ai-discern.svg') no-repeat
      center;
  }

  &:before {
    position: absolute;
    top: -50%;
    left: 100%;
    transform: translate(-50%, 50%);
    content: '限免';
    width: 36px;
    height: 16px;
    background: linear-gradient(
      108deg,
      rgba(54, 51, 47, 1) 0%,
      rgba(18, 16, 10, 1) 100%
    );
    border-radius: 8px;

    color: #f8dbb2;
    font-size: 12px;
    font-weight: bold;
    line-height: 16px;
  }
}
.tip-box-line {
  position: absolute;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.tip-box-content {
  position: absolute;
  background-color: #ffffff;
  padding: 18px 16px;
  border-radius: 4px;

  .title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .text {
    text-align: left;
    color: #333333;
    font-size: 14px;
    text-align: justify;
    line-height: 1.5;
    margin-bottom: 19px;
  }

  & > .control {
    display: flex;
    align-items: center;
    justify-content: space-between;
    & .mark {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 16px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #999999;
      opacity: 1;
      & > span {
        color: #555;
      }
    }
    & > .main {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    & .skip {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 16px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #999999;
      opacity: 1;
      margin-right: 10px;
      cursor: pointer;
    }
    & .next {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 52px;
      height: 22px;
      background: #5778fb;
      opacity: 1;
      border-radius: 11px;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
    }
  }
}

.slider-timeline {
  position: absolute;
  z-index: 20;
  left: 188px;

  .slider-box {
    position: absolute;
    left: -6px;
    width: 13px;
    height: 16px;
    background-color: #5778fb;
    clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
    cursor: -webkit-grab;
    cursor: grab;
    touch-action: pan-x;
  }

  .slider-line {
    position: absolute;
    top: 10px;
    width: 1px;
    height: 140px;
    background-color: #5778fb;

    div {
      position: relative;
      top: 0;
      left: -2px;
      width: 5px;
      height: 100%;
      cursor: -webkit-grab;
      cursor: grab;
      touch-action: pan-x;
    }
  }
}

.show-hide-btn {
  position: absolute;
  left: 24px;
  bottom: 0;
  height: 12%;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  div {
    width: 24px;
    height: 24px;
    background-color: #d7daf2;
    margin-right: 1px;
    cursor: pointer;
    line-height: 24px;

    > i.iconfont {
      font-size: 12px;
    }
  }

  .hide-status {
    background-color: #ededf2;
  }
}
</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitleGuidance.vue